import React from 'react';
import { useFileViewerSubRegionContext } from 'js/file_viewer/contexts/file_viewer.context';
import { PreviewContent } from 'js/file_viewer/preview_content/preview_content';
// All maf sub regions are react lazy components even if the component is directly imported.
// Wrap this in a suspense to make sure we never suspend parent components.
const asyncComponent = (Previewer) => (props) => (React.createElement(React.Suspense, { fallback: null },
    React.createElement(Previewer, { ...props })));
/**
 * Wraps the Preview component as a sub region when using the MAF framework for tracking
 * component visually complete and other performance metrics of the feature.
 */
export const usePreviewContent = () => {
    const { previewContent } = useFileViewerSubRegionContext();
    return React.useMemo(() => (previewContent ? asyncComponent(previewContent) : PreviewContent), [previewContent]);
};
//# sourceMappingURL=preview_content_sub_region.preenvesnextjs.map
